import { Button } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

import { useValuesVisibility } from '../../hooks/useValuesVisibility';

export function ToggleButton() {
  const { valuesVisibility, toggle } = useValuesVisibility();

  const valuesIsVisible = valuesVisibility === 'visible';

  return (
    <Button
      color='default'
      variant='filled'
      className='max-md:mt-2'
      icon={valuesIsVisible ? <Icon.EyeOff size={16} /> : <Icon.Eye size={16} />}
      onClick={toggle}
      aria-pressed={valuesIsVisible}
    >
      {`${valuesIsVisible ? 'Esconder' : 'Exibir'} valores`}
    </Button>
  );
}
